// This map should correspond with app/services/calculate_expiry_date.rb

const expirationInDays = {
  never: 0,
  '365d': 365,
  '90d': 90,
  '28d': 28,
  '14d': 14,
  '7d': 7,
};

const expirationLabels = {
  never: '',
  '365d': '1 Year',
  '90d': '3 Months',
  '28d': '1 Month',
  '14d': '2 Weeks',
  '7d': '1 Week',
};

export const getExpirationLabel = (
  expiry: keyof typeof expirationLabels
): string => {
  if (!expiry) return;

  return expirationLabels[expiry];
};

export const getExpirationDate = (
  expiry: keyof typeof expirationInDays
): string | null => {
  const days = expirationInDays[expiry];

  if (!days) {
    return null;
  }

  const expiration = new Date();
  expiration.setDate(expiration.getDate() + days);

  return expiration.toISOString();
};
